import { handlePossibleStartPageLanguageUrlPath, isContentPathEqualToUrlPath } from '../Utils';
import { BreadcrumbAndBannerComponent } from './BreadCrumbAndBannerComponent';
import { useContentDeliveryAPI, useEpiserver } from '@episerver/spa-core';
import { BannerInfo, emptyBannerInfo } from '../../../Models/Interfaces/Banner/BannerInfo';
import { getClassifiedBannerType } from './ClassifyBanner';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import store, { AppActionTypes } from '../../../store';

type BreadcrumbsProps = {
    currentContent: IContent;
    isNewsPage?: boolean;
};

export const Breadcrumb = ({ isNewsPage = false, currentContent }: BreadcrumbsProps) => {
    const api = useContentDeliveryAPI();
    const ctx = useEpiserver();
    const location = useLocation();
    const currentPath = location.pathname;

    const [parentInfo, setParentInfo] = useState<{ parentPath: string; parentName: string }>({
        parentPath: '',
        parentName: '',
    });
    const [breadcrumbAndBannerInfo, setBreadcrumbAndBannerInfo] = useState<BannerInfo>(emptyBannerInfo);
    const [breadcrumbWrapperClass, setBreadcrumbWrapperClass] = useState<string>('breadcrumb-wrapper');

    const content = currentContent as any;

    useEffect(() => {
        // må gjennom dette pga sjekke om man har en foreldre side i hiariket som ligger i menyen
        if (currentContent) {
            api.getAncestors(currentContent).then((ancestors) => {
                if (ancestors && ancestors.length > 0) {
                    let parentPath = ancestors[0].contentType.includes('StartPage')
                        ? '/'
                        : ancestors[0].contentLink.url;
                    let parentName = ancestors[0].name.toString();

                    // check if currrent page is in top menu
                    let subMenu = '';

                    store.getState()?.menuIds.forEach((guid: string[]) => {
                        if (currentContent.contentLink.guidValue == guid[0]) {
                            subMenu = guid[1];
                            store.dispatch({ type: AppActionTypes.SET_MENU_WITH_FOCUS, payload: subMenu });
                        }
                    });

                    let hasBanner = false;
                    let foundNewsListParent = false;

                    for (let i = 0; i < ancestors.length; i++) {
                        const currentAncestor = ancestors[i];

                        // check if page should have bannes
                        if (
                            currentAncestor.contentType.includes('EnkeltDomstolPage') ||
                            currentAncestor.contentType.includes('FinnmarkskommisjonenPage')
                        ) {
                            const bannerInfo = getClassifiedBannerType(currentAncestor);
                            setBreadcrumbAndBannerInfo(bannerInfo);
                            setBreadcrumbWrapperClass('breadcrumb-wrapper banner');
                            hasBanner = true;
                        }

                        // check if page has an ancestor which is in top menu
                        if (subMenu == '') {
                            store.getState()?.menuIds.forEach((guid: string[]) => {
                                if (currentAncestor.contentLink.guidValue == guid[0]) {
                                    subMenu = guid[1];
                                    store.dispatch({ type: AppActionTypes.SET_MENU_WITH_FOCUS, payload: subMenu });
                                }
                            });
                        }

                        // find first newslist page
                        if (
                            !foundNewsListParent &&
                            currentContent.contentType.includes('NewsPage') &&
                            currentAncestor.contentType.includes('NewsFolderPage') &&
                            ancestors[i + 1] &&
                            !ancestors[i + 1].contentType.includes('NewsFolderPage')
                        ) {
                            const newslistparent = ancestors[i + 1];
                            parentPath = newslistparent.contentLink.url;
                            parentName = newslistparent.name.toString();
                            foundNewsListParent = true;
                        }
                    }

                    if (!hasBanner) {
                        setBreadcrumbAndBannerInfo({ bannerName: '', bannerType: 0 });
                        setBreadcrumbWrapperClass('breadcrumb-wrapper');
                        const breadcrumbMarginTopEl = document.getElementsByClassName('breadcrumb-margin');
                        if (breadcrumbMarginTopEl != null && breadcrumbMarginTopEl.length > 0) {
                            breadcrumbMarginTopEl[0].classList.remove('banner');
                        }
                    }

                    setParentInfo({ parentName: parentName, parentPath: parentPath });

                    if (subMenu == '') {
                        store.dispatch({ type: AppActionTypes.SET_MENU_WITH_FOCUS, payload: '' });
                    }
                }
            });
        } else {
            setParentInfo({ parentName: '', parentPath: '' });
        }
    }, [currentContent.url, ctx.Language]);

    if (ctx.isServerSideRendering()) {
        return null;
    }

    if (content?.parentPageName?.value != '' && !currentContent?.contentType?.includes('NewsPage')) {
        const tempParentPageName =
            parentInfo.parentName != '' || ctx.Language != currentContent.language.name
                ? parentInfo.parentName
                : content?.parentPageName?.value;
        return (
            <BreadcrumbAndBannerComponent
                heading={content?.heading?.value}
                iContent={currentContent}
                parentPageHref={handlePossibleStartPageLanguageUrlPath(
                    parentInfo.parentPath != '' ? parentInfo.parentPath : currentContent.parentLink.url
                )}
                parentPageName={tempParentPageName}
                breadcrumbwrappclass={breadcrumbWrapperClass}
                bannerInfo={breadcrumbAndBannerInfo}
            />
        );
    }

    return (
        <>
            {isContentPathEqualToUrlPath(currentContent.url, currentPath) && parentInfo.parentName != '' && (
                <BreadcrumbAndBannerComponent
                    heading={content?.heading?.value}
                    iContent={currentContent}
                    parentPageHref={
                        !isNewsPage
                            ? handlePossibleStartPageLanguageUrlPath(currentContent?.parentLink?.url)
                            : handlePossibleStartPageLanguageUrlPath(parentInfo.parentPath)
                    }
                    parentPageName={parentInfo.parentName}
                    breadcrumbwrappclass={breadcrumbWrapperClass}
                    bannerInfo={breadcrumbAndBannerInfo}
                />
            )}
        </>
    );
};

export default Breadcrumb;
